export default __webpack_public_path__ + "static/media/In-Person.363a7697.jpg";